import type { KebabToCamel } from '../types';

/** Converts kebab-case string to camelCase. */
const kebabToCamel = <S extends string>(str: S): KebabToCamel<S> => {
  return str
    .replace(/^-+/g, '')
    .replace(/-+(.)?/g, (_, p1: string) => p1.toUpperCase()) as KebabToCamel<S>;
};

export default kebabToCamel;
